import { TIERS } from 'src/tiers';
import type { Partner } from 'src/types';

type GroupedPartners = Record<Partner['tier'], Partner[]>;

export const groupPartners = (partners: Partner[]): GroupedPartners =>
  partners.reduce<GroupedPartners>(
    (carry, partner) => ({
      ...carry,
      [partner.tier]: [...(carry[partner.tier] || []), partner],
    }),
    {} as GroupedPartners,
  );

export const makePartnerSuggestions = (
  partners: Partner[],
  regionFilter?: string,
): Array<{
  label: string;
  suggestions: Array<{ text: string; value: Partner }>;
}> => {
  const grouped = groupPartners(partners);

  return TIERS.map(({ tier, label }) =>
    makeSuggestion(grouped, label, tier, regionFilter),
  );
};

const makeSuggestion = (
  partners: GroupedPartners,
  label: string,
  groupName: Partner['tier'],
  regionFilter?: string,
) => ({
  label,
  suggestions:
    partners[groupName]
      ?.filter((partner) => {
        if (!regionFilter || regionFilter === 'All') {
          return true;
        }
        return (
          partner.hasApacIntegration || ['AU', 'NZ'].includes(regionFilter)
        );
      })
      .map((filteredPartner) => ({
        text: filteredPartner.name,
        value: filteredPartner,
      })) || [],
});
